import shuffle from '@/utils/shuffle.js';


const WORKOUT_ITEMS = [
  { text: 'Pushups', amounts: [ 15, 30, 50 ] },
  { text: 'Jumping jacks', amounts: [ 15, 30, 50 ] },
  { text: 'Situps', amounts: [ 15, 30, 50 ] },
  { text: 'Crunches', amounts: [ 15, 30, 50 ] },
  { text: 'Tricep dips', amounts: [ 15, 30, 50 ] },
  { text: 'Burpees', amounts: [ 15, 30, 50 ] },
  { text: 'Squats', amounts: [ 15, 30, 50 ] },
  { text: 'Lunges (both sides)', amounts: [ 14, 30, 50 ] },
  { text: 'Wall sit', amounts: [ '1 minute', '3 minutes', '5 minutes' ] },
  { text: 'Lateral lunges (both sides)', amounts: [ 14, 30, 50 ] },
  { text: 'Calf raises (one side at a time)', amounts: [ 14, 30, 50 ] },
  { text: 'Squat jumps', amounts: [ 15, 30, 50 ] },
  { text: 'Forearm plank', amounts: [ '1 minute', '3 minutes', '5 minutes' ] },
  { text: 'Mountain climbers', amounts: [ 15, 30, 50 ] },
  { text: 'Bicycle crunches', amounts: [ 15, 30, 50 ] },
  { text: 'Russian twists (both sides)', amounts: [ 14, 30, 50 ] },
  { text: 'Side plank', amounts: [ '1 minute', '3 minutes', '5 minutes' ] },
  { text: 'Side crunches (both sides)', amounts: [ 14, 30, 50 ] },
  { text: 'Reverse lunges (both sides)', amounts: [ 14, 30, 50 ] },
  { text: 'High knees', amounts: [ '1 minute', '3 minutes', '5 minutes' ] },
  { text: 'Running in place', amounts: [ '1 minute', '3 minutes', '5 minutes' ] },
  { text: 'Lateral leg raises (both sides)', amounts: [ 14, 30, 50 ] },
  { text: 'Toe touches', amounts: [ 15, 30, 50 ] },
  { text: 'Reverse crunches', amounts: [ 15, 30, 50 ] },
  { text: 'Flutter kicks', amounts: [ 15, 30, 50 ] },
  { text: 'Glute bridge', amounts: [ 15, 30, 50 ] },
  { text: 'Tricep pushups', amounts: [ 15, 30, 50 ] },
  { text: 'Speed skaters', amounts: [ 14, 30, 50 ] },
  { text: 'Butt kicks', amounts: [ '1 minute', '3 minutes', '5 minutes' ] },
  { text: 'Inchworms', amounts: [ 15, 30, 50 ] },
  { text: 'V-ups', amounts: [ 15, 30, 50 ] },
  { text: 'Supermans', amounts: [ 15, 30, 50 ] },
  { text: 'Jumping lunges (both sides)', amounts: [ 14, 30, 50 ] },
];

// Shuffle once here before exporting
shuffle(WORKOUT_ITEMS);


export default WORKOUT_ITEMS;